import { render, staticRenderFns } from "./DetalhesWorkflow.vue?vue&type=template&id=13e67869&scoped=true"
import script from "./DetalhesWorkflow.vue?vue&type=script&lang=js"
export * from "./DetalhesWorkflow.vue?vue&type=script&lang=js"
import style0 from "./DetalhesWorkflow.vue?vue&type=style&index=0&id=13e67869&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e67869",
  null
  
)

export default component.exports